import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import {UserService} from "../../services/apiCalls/userService/user.service";
import { transactionFilters, transactionProp} from "../../interfaces/iresponse";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SuperAdminService } from 'src/app/services/apiCalls/superAdminService/super-admin.service';
import { genderType } from '../enrol-riders/enrol-riders.component';

type optionType = 'agent'|'not-agent'| '';
@Component({
  selector: 'app-transaction-report',
  templateUrl: './transaction-report.component.html',
  styleUrls: ['./transaction-report.component.css']
})
export class TransactionReportComponent implements OnInit {
breadCrumb: any;
  loadingData: boolean = false;
  currentUser: any = null;
  transactions: transactionProp[] = [];
  selctType: optionType = '';
  Roles: any = [];
  currentPage: number = 1;
  perPage: number = 10;
  showData: boolean = true;
  agents: genderType[] = [
    {id: 0, name: 'Select Agent', value: ''}
  ];
  categories: genderType[] = [
    {id: 0, name: 'Select Category', value: ''}
  ];
  zones: genderType[] = [
    {id: 0, name: 'Select Zone', value: ''}
  ];
  currentDate = new Date(Date.now()).toISOString();
  constructor(
    private utilService: UtilService, 
    private superAdminService: SuperAdminService,
    private userService: UserService) {
    this.currentUser = this.utilService.getAuthUser();
  }

  filterForm = new FormGroup({
    from: new FormControl( '', Validators.required),
    to: new FormControl( '', Validators.required),
    agent_id: new FormControl( '', Validators.required),
    category: new FormControl('', Validators.required),
    zone_id: new FormControl('', Validators.required),
  })

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Revenue report',
      parent: 'Reports',
      subLink: null
    };
    this.getTransactionReport({
      to: this.currentDate, from: '',
      zone_id: 0, category: '', agent_id: 0
    });
    const userRole = this.utilService.Roles[0] === 'agent';
    if(!userRole){
      this.getAgents();
    }
    this.getCategories();
    this.getZones()
  }

  public checkPrivilege(users : Array<string>) {
    for (const user of users) {
      if (this.Roles.includes(user)) {
        return true;
      }
    }
    return false;
  }


  getTransactionReport(filters: transactionFilters) {
    this.loadingData = true;
    this.showData = false;
    this.userService.getTransactions(filters, this.currentPage, this.perPage)
      .subscribe((res) => {
        this.transactions = res;
        this.utilService.startDatatable('revenue-reports'); 
        this.loadingData = false;
        this.showData = true;
      }, error => {
        this.utilService.startDatatable('revenue-reports');
        this.loadingData = false;
        this.showData = true;
      });
  }

  getAgents(){
    this.superAdminService.getAllAgentsForFilter().subscribe({
      next: (res)=>{
        const {data}=res;
        this.setOptionFields(this.agents, data, 'agent');
      }
    })
  }

  getCategories(){
    this.userService.getCategories('').subscribe({
      next: (response)=>{
        const filter = response.filter((c)=> c.status.toLowerCase() === 'active');
        this.setOptionFields(this.categories, filter, 'not-agent');
      }
    })
  }

  getZones(){
    this.userService.getAllZones('').subscribe({
      next: (response)=>{
        const zones = response.data;
        this.setOptionFields(this.zones, zones, 'not-agent');
      }
    })
  }

  setOptionFields(originalArray :genderType[], passedArray : any[], selectCase: optionType){
    let selectArray:genderType[] = originalArray;
    for(let o of passedArray){
      const optionObject: genderType ={
        id: o.id,
        name: selectCase === 'agent' ? o.full_name : o.name?.toLowerCase(),
        value: String(o.id)
      }
      selectArray?.push(optionObject);
    }
    originalArray = selectArray;
    return originalArray;
  }

  onFilterForm(){
    const from = this.getControlValue('from')
    const to = this.getControlValue('to');
    const agent_id = this.getControlValue('agent_id');
    const category = this.getControlValue('category');
    const zone_id = this.getControlValue('zone_id');
    const controls = {from, to, category, agent_id, zone_id};
    this.getTransactionReport(controls);
  }

  getControlValue(cntrl: string){
    const control = this.filterForm.get(cntrl)?.value;
    return control;
  }

  onFormValidate(){
    if( 
      this.getControlValue('to') > this.currentDate && this.getControlValue('from') > this.currentDate  ||
      this.getControlValue('to') !== '' && this.getControlValue('from') === '' || 
      this.getControlValue('to') === '' && this.getControlValue('from') !== '' ||
      this.getControlValue('from') > this.getControlValue('to') || this.getControlValue('to') > this.currentDate
     ){
      return true;
    }
    if(
      // this.getControlValue('agent_id') !== '' || 
      this.getControlValue('from') !== '' || 
      this.getControlValue('to') !== '' ||
      this.getControlValue('category') !== '' || 
      this.getControlValue('zone_id') !== ''
    ) return false;
      return true;
  } 

  onFormReset(){
    this.filterForm.reset({
      agent_id: '',
      from: '',
      to: '',
      category: '',
      zone_id: ''
    });
  }
}
